import type { ReactNode } from "react";
import { cx } from "./cx";

export function EmptyState({
  icon,
  title,
  children,
  actions,
  className,
  level = 2,
}: {
  icon?: ReactNode;
  title: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
  level?: 1 | 2;
}) {
  const Heading = level === 1 ? "h1" : "h2";
  return (
    <div className={cx("mx-auto flex max-w-[460px] flex-col items-center px-4 py-12 text-center", className)}>
      {icon ? (
        <div className="mb-3 grid size-10 place-items-center rounded-xl bg-surface-2 text-muted [&_svg]:size-5">
          {icon}
        </div>
      ) : null}
      <Heading className="m-0 text-xl font-semibold text-fg">{title}</Heading>
      {children ? <div className="mt-1.5 text-muted">{children}</div> : null}
      {actions ? <div className="mt-4 flex flex-wrap justify-center gap-2">{actions}</div> : null}
    </div>
  );
}
